/**
 * AccessContainer component.
 */
import styled from 'styled-components';
import withOpacity from '@shared/components/utils/hoc/withOpacity';

/**
 * Styled access container.
 */
const AccessContainer = styled.div<React.CSSProperties>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

export default withOpacity(AccessContainer);
